/* eslint-disable */
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import Add from "assets/addAccordianNew.png";
import RemoveIcon from "assets/minus.png";
import { COLORS, WEIGHT } from "theme";
import { HOST } from "api/apiClient";

const Table = ({ trucks, type, Icon, keys, icons, small, OBJ }) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Accordion
      sx={{ background: "#ffffff", borderBottom: "1px solid #363636" }}
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <AccordionSummary
        expandIcon={
          <img
            src={expanded === "panel1" ? RemoveIcon : Add}
            alt="remove"
            style={{ height: small ? "26px" : "36px" }}
          />
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box display="flex" alignItems="center">
          <img
            src={OBJ["DV"][type]["icon"] ? HOST + OBJ["DV"][type]["icon"] : ""}
            alt={OBJ["DV"][type]["alt"]}
          />
          <Text
            fontSize={small ? "12px" : "15px"}
            fontWeight="bold"
            textColor="black"
            margin="0 8px"
          >
            {type}
          </Text>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Text textColor="#B8B8B8" fontSize="15px" margin="0">
          <table
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 0,
            }}
          >
            <tr
              style={{
                background: "#F8F9FA",
                display: "flex",
                alignItems: "center",

                justifyContent: "space-around",
              }}
            >
              <td
                style={{
                  fontSize: small ? "12px" : "18px",
                  color: "black",
                  border: "none",
                  width: "40%",
                  textAlign: "left",
                  padding: "24px 0",
                }}
              ></td>
              <td
                style={{
                  fontSize: small ? "12px" : "18px",
                  color: "black",
                  border: "none",
                  fontWeight: WEIGHT.bold,
                  width: "30%",
                  textAlign: "left",
                }}
              >
                DV
              </td>
              <td
                style={{
                  fontSize: small ? "12px" : "18px",
                  color: "black",
                  fontWeight: WEIGHT.bold,

                  border: "none",
                  width: "30%",
                  textAlign: "left",
                }}
              >
                PV
              </td>
              {/* <td
                style={{
                  fontSize: small ? "12px" : "18px",
                  color: "black",
                  fontWeight: WEIGHT.bold,
                  border: "none",
                  width: "30%",
                  textAlign: "left",
                }}
              >
                HD
              </td> */}
            </tr>
            {keys.map((item, index) => {
              if (item !== "icon" && item !== "alt")
                return (
                  <tr
                    style={{
                      background: index % 2 === 0 ? "#F8F9FA" : COLORS.white,
                      display: "flex",
                      alignItems: "center",

                      justifyContent: "space-around",
                    }}
                  >
                    <td
                      style={{
                        fontSize: small ? "12px" : "18px",
                        color: "black",
                        border: "none",
                        width: "40%",
                        textAlign: "left",
                        padding: "24px 0",
                        fontWeight: WEIGHT.bold,
                      }}
                    >
                      {item}
                    </td>
                    <td
                      style={{
                        fontSize: small ? "12px" : "18px",
                        color: "black",
                        border: "none",
                        width: "30%",
                        textAlign: "left",
                      }}
                    >
                      {OBJ.DV[type][item]}
                    </td>
                    <td
                      style={{
                        fontSize: small ? "12px" : "18px",
                        color: "black",
                        border: "none",
                        width: "30%",
                        textAlign: "left",
                      }}
                    >
                      {OBJ.PV[type][item]}
                    </td>
                    {/* <td
                      style={{
                        fontSize: small ? "12px" : "18px",
                        color: "black",
                        border: "none",
                        width: "30%",
                        textAlign: "left",
                      }}
                    >
                      {OBJ.HD[type][item]}
                    </td> */}
                  </tr>
                );
            })}
          </table>
        </Text>
      </AccordionDetails>
    </Accordion>
  );
};

export default Table;
